import { Game } from '../game.model';
import { Player } from '../player.model';

export class Answered {
  game: Game;
  player: Player;
}
